






























































































































import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Form,
} from "vant";
import WeMixin from "@/components/weMixin";
import api, { apibase, WeAxiosRequestConfig } from "@/components/http/api";

import { CouponRequestInfo } from "../coupon/CouponApi";

declare const $: any;
declare const turnplate: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Form.name]: Form,
  },
})
export default class FollowRaffle extends mixins(WeMixin) {
  private couponRequestInfo: CouponRequestInfo = {} as CouponRequestInfo;

  private checkCus: boolean = false;
  private isShowError: boolean = false;
  private showText: string = "";

  private rTime: number = 0;
  private random: any;
  private prizeName: string = "";
  private prizeName1: string = "";
  private prizeName2: string = "";

  protected created() {
    this.couponRequestInfo.couponopenid = this.$route.query.openid as string;
    this.getCustomerInfo();
  }

  protected mounted() {
    const interval = window.setInterval(() => {
      if (--this.rTime <= 0) {
        window.clearInterval(interval);
        this.drawRouletteWheel();
      }
    }, 500);
  }

  protected getCustomerInfo() {
    api.get("/weixinmp/xsyx/myuser/getCustomerInfo").then((res: any) => {
      if (res.data.flag === "0") {
        api
          .post("/weixinmp/xsyx/myuser/checkIsSubscribe", {})
          .then((res1: any) => {
            if (!res1.data) {
              this.checkCus = false;
              this.isShowError = true;
              this.showText = "未关注公众号无法抽奖";
            } else {
              api
                .post("/weixinmp/xsyx/coupon/checkRaffleRepeat", {})
                .then((res2: any) => {
                  if (res2.data.flag === "1") {
                    api
                      .post("/weixinmp/xsyx/coupon/checkFollowTime", {})
                      .then((res3: any) => {
                        if (res3.data.flag) {
                          this.checkCus = true;
                          this.isShowError = false;
                        } else {
                          this.checkCus = false;
                          this.isShowError = true;
                          if (res3.data.msgFlag === 0) {
                            this.showText = "注册信息有误";
                          } else if (res3.data.msgFlag === 1) {
                            this.showText = "非新注册用户，无法参与抽奖";
                          } else if (res3.data.msgFlag === 2) {
                            this.showText = "注册时间超过7天，无法参与抽奖";
                          }
                        }
                      });
                  } else {
                    this.checkCus = false;
                    this.isShowError = true;
                    this.showText = "已参加过该活动，无法重复抽奖";
                  }
                });
            }
          });
      } else if (res.data.flag === "1") {
        this.checkCus = false;
        this.isShowError = true;
        this.showText = "未注册用户无法抽奖，请注册";
      }
    });
  }

  protected pointerClick() {
    if (turnplate.bRotate) {
      return;
    }
    turnplate.bRotate = !turnplate.bRotate;
    api.get("/weixinmp/xsyx/coupon/getRaffle").then((res: any) => {
      const result = res.data;
      let item = 1;
      if (result === "1") {
        item = 2;
      } else if (result === "2") {
        item = 3;
      } else if (result === "3") {
        item = 1;
      }
      if (result === "") {
        this.prizeName = "奖项已全部抽完";
        $(".mask-black,#no-modal").css("display", "block");
      } else {
        this.couponRequestInfo.activityid = result;
        $("#wheelcanvas").rotate({
          angle: 0,
          animateTo: 7200,
          duration: 8000,
        });
        api
          .post("/weixinmp/xsyx/coupon/raffleGetCoupon", this.couponRequestInfo)
          .then((res1: any) => {
            if (res1.data.EIFlag) {
              this.prizeName = res1.data.msg;
              this.prizeName1 = res1.data.msg1;
              this.prizeName2 = res1.data.msg2;
              this.rotateFn(item, turnplate.restaraunts[item - 1]);
            } else {
              this.prizeName = res1.data.msg;
              this.rotateFnNo(item, turnplate.restaraunts[item - 1]);
              // $("#wheelcanvas").stopRotate();
              // $(".mask-black,#no-modal").css("display", "block");
              // turnplate.bRotate = !turnplate.bRotate;
            }
          });
      }
    });
  }

  protected rnd(n: any, m: any) {
    api.get("/weixinmp/xsyx/coupon/getRaffle").then((res: any) => {
      this.random = res.data;
      console.log(res.data);
    });
    // const random = Math.floor(Math.random() * (m - n + 1) + n);
    // return res.data;
  }

  protected rotateFn(item: any, txt: any) {
    let angles =
      item * (360 / turnplate.restaraunts.length) -
      360 / (turnplate.restaraunts.length * 2);
    if (angles < 270) {
      angles = 270 - angles;
    } else {
      angles = 360 - angles + 270;
    }
    $("#wheelcanvas").stopRotate();
    $("#wheelcanvas").rotate({
      angle: 0,
      animateTo: angles + 1800,
      duration: 8000,
      callback() {
        $(".mask-black,#zj-modal").css("display", "block");
        turnplate.bRotate = !turnplate.bRotate;
      },
    });
  }

  protected rotateFnNo(item: any, txt: any) {
    let angles =
      item * (360 / turnplate.restaraunts.length) -
      360 / (turnplate.restaraunts.length * 2);
    if (angles < 270) {
      angles = 270 - angles;
    } else {
      angles = 360 - angles + 270;
    }
    $("#wheelcanvas").stopRotate();
    $("#wheelcanvas").rotate({
      angle: 0,
      animateTo: angles + 1800,
      duration: 8000,
      callback() {
        $(".mask-black,#no-modal").css("display", "block");
        turnplate.bRotate = !turnplate.bRotate;
      },
    });
  }

  protected showRules() {
    $(".mask-black,#xx-modal").css("display", "block");
  }

  protected closeRules() {
    $(".mask-black,#xx-modal").css("display", "none");
  }

  protected drawRouletteWheel() {
    const canvas: any = document.getElementById("wheelcanvas");
    if (canvas.getContext) {
      // 根据奖品个数计算圆周角度
      const arc = Math.PI / (turnplate.restaraunts.length / 2);
      const ctx = canvas.getContext("2d");
      // 在给定矩形内清空一个矩形
      ctx.clearRect(0, 0, 422, 422);
      // strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
      ctx.strokeStyle = "#FFBE04";
      // font 属性设置或返回画布上文本内容的当前字体属性
      ctx.font = "16px Microsoft YaHei";
      for (let i = 0; i < turnplate.restaraunts.length; i++) {
        const angle = turnplate.startAngle + i * arc;
        ctx.fillStyle = turnplate.colors[i];
        ctx.beginPath();
        // arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
        ctx.arc(211, 211, turnplate.outsideRadius, angle, angle + arc, false);
        ctx.arc(211, 211, turnplate.insideRadius, angle + arc, angle, true);
        ctx.stroke();
        ctx.fill();
        // 锁画布(为了保存之前的画布状态)
        ctx.save();

        // ----绘制奖品开始----
        ctx.fillStyle = "#d11615";
        let text = turnplate.restaraunts[i];
        const lineHeight = 17;
        // translate方法重新映射画布上的 (0,0) 位置
        ctx.translate(
          211 + Math.cos(angle + arc / 2) * turnplate.textRadius,
          211 + Math.sin(angle + arc / 2) * turnplate.textRadius
        );

        // rotate方法旋转当前的绘图
        ctx.rotate(angle + arc / 2 + Math.PI / 2);

        // 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变)
        if (text.indexOf("M") > 0) {
          // 流量包
          const texts = text.split("M");
          for (let j = 0; j < texts.length; j++) {
            ctx.font =
              j == 0 ? "bold 20px Microsoft YaHei" : "16px Microsoft YaHei";
            if (j == 0) {
              ctx.fillText(
                texts[j] + "M",
                -ctx.measureText(texts[j] + "M").width / 2,
                j * lineHeight
              );
            } else {
              ctx.fillText(
                texts[j],
                -ctx.measureText(texts[j]).width / 2,
                j * lineHeight
              );
            }
          }
        } else if (text.indexOf("M") == -1 && text.length > 6) {
          // 奖品名称长度超过一定范围
          text = text.substring(0, 6) + "||" + text.substring(6);
          const texts = text.split("||");
          for (let j = 0; j < texts.length; j++) {
            ctx.fillText(
              texts[j],
              -ctx.measureText(texts[j]).width / 2,
              j * lineHeight
            );
          }
        } else {
          // 在画布上绘制填色的文本。文本的默认颜色是黑色
          // measureText()方法返回包含一个对象，该对象包含以像素计的指定字体宽度
          ctx.fillText(text, -ctx.measureText(text).width / 2, 0);
        }

        // 添加对应图标
        if (text.indexOf("闪币") > 0) {
          const img: any = document.getElementById("shan-img");
          img.onload = () => {
            ctx.drawImage(img, -15, 10);
          };
          ctx.drawImage(img, -15, 10);
        } else if (text.indexOf("谢谢参与") >= 0) {
          const img: any = document.getElementById("sorry-img");
          img.onload = () => {
            ctx.drawImage(img, -15, 10);
          };
          ctx.drawImage(img, -15, 10);
        }
        // 把当前画布返回（调整）到上一个save()状态之前
        ctx.restore();
        // ----绘制奖品结束----
      }
    }
  }
}
